/**
 * Whether a pay period's own last day has already passed, given today's
 * real date: docs/product/scheduling-model.md's schedule states says
 * "periods before the current one are read only for agents." Split out so
 * AgentCopySchedulePage.tsx only exports the component, which Fast Refresh
 * requires, and so this is exercised directly in tests against dates the
 * real clock will not reach for years, rather than only ever against
 * whatever today happens to be.
 */
export function isPeriodPast(periodEndISO: string, todayISO: string): boolean {
  return todayISO > periodEndISO
}
